export default "__VITE_PUBLIC_ASSET__d0802879__"